import React, { useState, lazy, Component } from 'react';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
const pricingImgBase = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/ChatGPT_Image_2_mar_2026_03_36_32_p.m._1.webp?v=1772462225';
const valueBreakdown = [{
  item: 'Método Jabones Artesanales',
  value: 24.99
}, {
  item: 'Listado Exclusivo de Proveedores',
  value: 14.99
}, {
  item: 'Calculadora Inteligente de Ganancias™',
  value: 14.99
}, {
  item: 'Master de Marketing para Jabones™',
  value: 14.99
}, {
  item: 'Maestría en Ventas por WhatsApp™',
  value: 17.99
}, {
  item: 'Cosmética Sólida Profesional',
  value: 14.99
}, {
  item: 'Velas Artesanales',
  value: 14.99
}, {
  item: 'Certificado',
  value: 17.99
}, {
  item: 'Membresía VIP',
  value: 17.99
}];
export function Pricing() {
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  const totalValue = valueBreakdown.reduce((sum, item) => sum + item.value, 0);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const handleBuyClick = () => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    const variantId = '53162996171116';
    try {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        });
      }
    } catch {}
    const qs = (window.location.search || '').replace(/^\?/, '');
    const returnTo = qs ? `/cart?${qs}` : '/cart';
    const url = `https://sanarconsciente.com/cart/add` + `?id=${encodeURIComponent(variantId)}` + `&quantity=1` + `&return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  };
  return <section className="w-full bg-[var(--bg-darker)] py-8 md:py-12 px-4" id="pricing-section" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-[var(--text-light)] mb-6 md:mb-8 text-center" data-id="element-230">
          ¿Cuánto vale todo esto?
        </h2>

        <div className="mb-6 md:mb-8" data-id="element-231">
          <img src={`${pricingImgBase}&width=700`} srcSet={`${pricingImgBase}&width=400 400w, ${pricingImgBase}&width=700 700w, ${pricingImgBase}&width=900 900w`} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 896px" alt="Método Jabones Artesanales" className="w-full h-auto rounded-lg shadow-xl" loading="lazy" decoding="async" width={896} height={504} data-id="element-232" />
        </div>

        <div className="bg-[var(--bg-card)] rounded-2xl p-4 md:p-6 lg:p-8 mb-6 md:mb-8 border-2 border-[var(--accent-orange)]" data-id="element-233">
          <div className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-234">
            {valueBreakdown.map((item, index) => <div key={index} className="flex justify-between items-center pb-2 md:pb-3 border-b border-gray-300" data-id="element-235">
                <span className="text-sm md:text-base lg:text-lg xl:text-xl text-[var(--text-light)]" data-id="element-236">
                  {item.item}
                </span>
                <span className="text-sm md:text-base lg:text-lg xl:text-xl font-bold text-[var(--accent-orange-light)]" data-id="element-237">
                  {isLoading ? '...' : formatPrice(item.value)}
                </span>
              </div>)}
          </div>

          <div className="pt-3 md:pt-4 border-t-2 border-[var(--accent-orange)]" data-id="element-238">
            <div className="flex justify-between items-center" data-id="element-239">
              <span className="text-xl md:text-2xl lg:text-3xl font-bold text-[var(--text-light)]" data-id="element-240">
                Valor Total:
              </span>
              <span className="text-2xl md:text-3xl lg:text-4xl font-black text-[var(--text-gray)]" data-id="element-241">
                {isLoading ? '...' : formatPrice(totalValue)}
              </span>
            </div>
          </div>

          <div className="mt-6 bg-gradient-to-br from-[var(--text-light)] to-[var(--text-gray)] rounded-xl p-5 md:p-6 text-center" data-id="element-242">
            <p className="text-sm md:text-base text-white/80 uppercase tracking-wider mb-3" data-id="element-243">
              HOY ACCEDES POR UN PAGO ÚNICO DE:
            </p>
            <div className="text-6xl md:text-7xl lg:text-8xl font-black text-[var(--accent-orange)] mb-5" data-id="element-244">
              {isLoading ? '...' : formatPrice(14.99)}
            </div>
            <button onClick={handleBuyClick} className="w-full bg-[var(--accent-orange)] hover:bg-[var(--accent-orange-hover)] text-white font-bold py-4 md:py-5 px-6 rounded-lg text-lg md:text-xl uppercase tracking-wide transition-colors duration-300 shadow-xl mb-3 flex items-center justify-center gap-2" data-id="element-245">
              EMPEZAR AHORA
              <ArrowRightIcon className="w-5 h-5" data-id="element-246" />
            </button>
            <p className="text-sm md:text-base text-white/90 mb-3" data-id="element-247">
              Acceso Inmediato a +45 Recetas + 8 Bonos
            </p>
            <div className="flex items-center justify-center gap-2 text-white/80 text-xs md:text-sm mb-2" data-id="element-248">
              <LockIcon className="w-4 h-4" data-id="element-249" />
              <p data-id="element-250">Pago único. SIN cargos mensuales. SIN costos ocultos.</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-6" data-id="element-251">
          <p className="text-sm md:text-base text-[var(--text-gray)] mb-2" data-id="element-252">
            Toda una colección por el valor de un simple almuerzo y durante
            tiempo limitado 🤍
          </p>
        </div>
      </div>
    </section>;
}